import React from "react";
import { BreadCrumb } from "../../common/BreadCrumb";
import { EvoucherInformationCard } from "./cards/EvoucherInformationCard";
import { RedemptionDetailsCard } from "./cards/RedemptionDetailsCard";
import { ExtendValidityDialog } from "./dialogs/ExtendValidityDialog";
import { StringHelper } from "../../../common/Helpers";
import RestClient from "../../../common/RestClient";
import {
  EVoucherExtensionStatus,
  EVoucherStatus,
  GenericMessages,
  ObjectType,
} from "../../../common/Constants";
import {
  AuthenticationManager,
  ResourceID,
} from "../../../common/AuthenticationManager";
import { EVoucherHistoryDialog } from "../../common/EVoucherHistoryDialog";
import {
  NavigationItem,
  NavigationSettings,
} from "../../common/NavigationSettings";
import { toast } from "react-toastify";
import ButtonActionDetailGroup from "../../common/ButtonActionDetailGroup";
import { EVoucherService } from "../../../services/EVoucherService";

export class EvoucherDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      evoucher: null,
      isShowExtendValidityDialog: false,
      isSubmitted: false,
      isShowBlockDialog: false,
      isExtendedValidity: false,
      evoucherExtension: null,
      showEVoucherHistoryDialog: false,
      refundEVoucherId: null,
    };
    this.eVoucherService = new EVoucherService();
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    const evoucherId = StringHelper.toNumber(id, 0);
    if (evoucherId > 0) {
      this.setState({ evoucherId }, this.loadEVoucher);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params !== this.props.match.params) {
      const { id } = this.props.match.params;
      const evoucherId = StringHelper.toNumber(id, 0);
      if (evoucherId > 0) {
        this.loadEVoucher();
      }
    }
  }

  loadEVoucher() {
    const { id } = this.props.match.params;
    RestClient.sendGetRequest(
      `/api/v1/evouchers/${id}`,
      (response) => {
        this.setState({ evoucher: response, refundEVoucherId: null });
        this.loadEvoucherExtensionRequest(response.id);
        if (response.status === EVoucherStatus.Refunded) {
          this.loadRefundEVoucher(id);
        }
      },
      (error) => {
        toast.error(error.message);
      }
    );
  }

  async loadRefundEVoucher(id) {
    const response = await this.eVoucherService.list({
      originalEVoucherId: id,
    });
    if (response.status === 200 && response.data.data.length > 0) {
      this.setState({ refundEVoucherId: response.data.data[0].id });
    }
  }

  loadEvoucherExtensionRequest = (evoucherId) => {
    const queryParameter = {
      evoucherId: evoucherId,
      requestStatus: EVoucherExtensionStatus.Pending,
    };
    RestClient.sendGetRequestWithParameters(
      `/api/v1/evoucher_extensions/`,
      queryParameter,
      (response) => {
        if (response?.data?.length > 0) {
          this.setState({
            isExtendedValidity: true,
            evoucherExtension: response.data[0],
          });
        }
      }
    );
  };

  extend = (extendRequest) => {
    RestClient.sendPostRequest(
      `/api/v1/evoucher_extensions/`,
      extendRequest,
      (response) => {
        this.setState({
          isExtendedValidity: true,
          evoucherExtension: response,
        });
        this.toggleExtendValidityDialog(false);
        toast.success(
          GenericMessages.CreationExtensionEvoucherSuccessfulMessage
        );
      },
      (error) => {
        toast.error(error.message);
      }
    );
  };
  toggleExtendValidityDialog = (visible) => {
    this.setState({ isShowExtendValidityDialog: visible });
  };

  redirectToEVoucherExtension = (evocherExtensionId) => {
    this.props.history.push(`/evouchers/extensions/${evocherExtensionId}`);
  };

  onViewHistoryClick = () => {
    this.setState({ showEVoucherHistoryDialog: true });
  };

  onHideHistoryDialog = () => {
    this.setState({ showEVoucherHistoryDialog: false });
  };

  getNavigationSettings = () => {
    return new NavigationSettings({
      parentModule: new NavigationItem({
        identifier: "evouchers",
        name: "eVouchers",
        standardized: false,
      }),
      activeModule: new NavigationItem({
        identifier: "evoucher-details",
        name: "eVoucher Details",
        standardized: false,
      }),
    });
  };

  render() {
    const {
      evoucher,
      isShowExtendValidityDialog,
      isSubmitted,
      isExtendedValidity,
      showEVoucherHistoryDialog,
      refundEVoucherId,
    } = this.state;
    return (
      <div className="main-content">
        <BreadCrumb navigationSettings={this.getNavigationSettings()} />
        <div className="section__content section__content--p30">
          <div className="container-fluid">
            <ButtonActionDetailGroup>
              {evoucher && evoucher.originalEVoucherId && (
                <ButtonActionDetailGroup.Item
                  className="btn btn-primary"
                  onClick={() =>
                    this.props.history.push(
                      `/evouchers/evouchers/${evoucher.originalEVoucherId}`
                    )
                  }
                >
                  View Origin eVoucher
                </ButtonActionDetailGroup.Item>
              )}
              {refundEVoucherId && (
                <ButtonActionDetailGroup.Item
                  className="btn btn-primary"
                  onClick={() =>
                    this.props.history.push(
                      `/evouchers/evouchers/${refundEVoucherId}`
                    )
                  }
                >
                  View Refund eVoucher
                </ButtonActionDetailGroup.Item>
              )}
              {(evoucher?.status === EVoucherStatus.Active ||
                evoucher?.status === EVoucherStatus.Expired) &&
                !isExtendedValidity &&
                AuthenticationManager.isAuthorized(
                  ResourceID.EVoucherViewDetailsExtendValidityButton
                ) && (
                  <ButtonActionDetailGroup.Item
                    className="btn btn-primary"
                    onClick={() => this.toggleExtendValidityDialog(true)}
                  >
                    Extend validity
                  </ButtonActionDetailGroup.Item>
                )}
              <ButtonActionDetailGroup.Item
                className="btn btn-outline-secondary"
                onClick={this.onViewHistoryClick}
              >
                History
              </ButtonActionDetailGroup.Item>
            </ButtonActionDetailGroup>
            {evoucher && <EvoucherInformationCard eVoucher={evoucher} />}
            {evoucher?.status === EVoucherStatus.Used && (
              <RedemptionDetailsCard eVoucherId={evoucher.id} />
            )}
          </div>
        </div>
        {isShowExtendValidityDialog && (
          <ExtendValidityDialog
            currentExpiredDate={evoucher.validityEnd}
            isSubmitted={isSubmitted}
            eVoucherId={evoucher.id}
            onCancel={() => this.toggleExtendValidityDialog(false)}
            onProceed={this.extend}
            reasonType={"Reason:"}
            placeholderText={"Enter reason for eVoucher extension"}
          />
        )}
        {showEVoucherHistoryDialog && (
          <EVoucherHistoryDialog
            objectId={evoucher.id}
            onClose={this.onHideHistoryDialog}
            url="/api/v1/history_logs"
            objectType={ObjectType.Evoucher}
            getStatusColor={EVoucherStatus.getColor}
          />
        )}
      </div>
    );
  }
}
